<template>
  <div>
    <div style="height: 30vh">
      <v-card class="fill-height pa-0 overflow-hidden" rounded="0">
        <v-img
          :gradient="'to right, rgba(0,0,0,.5), rgba(0,0,0,.3)'"
          src="https://images.unsplash.com/photo-1533134486753-c833f0ed4866?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
          class="fill-width fill-height d-block"
        ></v-img>
        <v-card-text class="d-flex justify-space-between align-center fill-height absolute left center-y pa-0">
          <v-slide-y-transition mode="in-out">
            <v-container>
              <v-card class="banner-text" color="transparent" elevation="0">
                <div class="banner-title text-h4 text-md-h4 white--text font-weight-bold">
                  Add products directly from your instagram posts
                </div>
              </v-card>
            </v-container>
          </v-slide-y-transition>
        </v-card-text>
      </v-card>
    </div>

    <v-container class="flex-grow-1 overflow-hidden mt-1">
      <div class="py-16 text-center" v-if="loading !== ''">
        <v-progress-circular color="primary" indeterminate size="25"></v-progress-circular>
        <div class="mx-auto mt-4" style="max-width: 300px">
          {{ loading }}
        </div>
      </div>
      <template v-else>
        <div v-if="view === 'username'" class="py-10 px-6">
          <v-text-field
            @keydown.enter="handleUsernameChange()" outlined label="Enter instagram username" v-model="username"
          ></v-text-field>
          <v-btn @click="handleUsernameChange()" color="primary" elevation="0">
            Continue
          </v-btn>
        </div>
        <template v-if="view === 'list'">
          <v-btn
            v-if="!multiple" @click="refresh()"
            fab dark small color="primary" fixed bottom right style="margin-bottom: 80px" elevation="0"
          >
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            @click="bulkAdd()" :loading="adding"
            v-if="multiple && selection.length" rounded class="px-4"
            dark color="primary" fixed bottom right elevation="0"
            style="position: fixed; right: 10px; bottom: 80px; z-index: 100"
          >
            Add {{ selection.length }} item(s)
          </v-btn>

          <div v-if="!multiple" class="d-flex align-center justify-space-between mb-5">
            <v-btn @click="multiple = true" color="grey lighten-1" small elevation="0" rounded class="px-4">
              <v-icon class="mr-2">mdi-format-list-checks</v-icon>
              Select multiple
            </v-btn>
            <v-btn @click="changeUsername()" color="grey lighten-1" small elevation="0" rounded class="px-4">
              <v-icon class="mr-2">mdi-plus</v-icon>
              New
            </v-btn>
          </div>
          <div v-else class="d-flex align-center mb-5">
            <v-btn @click="multiple = false" dark color="red lighten-1" small elevation="0" rounded class="px-4">
              <v-icon class="mr-2">mdi-close</v-icon>
              Cancel selection
            </v-btn>
          </div>

          <div v-for="(item, i) in displayPosts" :key="i" class="d-flex align-center">
            <v-checkbox
              v-if="multiple" :id="item.id" :value="selection.includes(item.id)"
              @change="handleSelectionChange(item.id, $event)" :disabled="adding"
            />
            <label :for="item.id" class="d-flex fill-width">
              <v-card
                class="position-relative flex-grow-1 rounded-lg d-flex flex-row align-center mb-2" light
                style="box-shadow: 0 4px 5px -1px rgba(0, 0, 0, .05); border: 1px solid rgba(0, 0, 0, .08)"
              >
                <div class="position-relative d-flex pa-2">
                  <ProxyImage :src="item.images[0]" width="100px"/>
                </div>
                <div class="px-3 py-3 px-md-4 flex-grow-1 d-flex flex-column align-start justify-center">
                  <div class="text-title black--text text-body-2 mb-1 fill-width">
                    {{ item.description ? `${ item.description.substr(0, 100) }..` : 'No caption' }}
                  </div>
                  <div v-if="!multiple" class="mt-2 fill-width">
                    <v-btn @click="select(item)" color="grey lighten-3" elevation="0" small>
                      <v-icon class="mr-1" color="primary" size="12">mdi-cart-plus</v-icon>
                      Add to cart
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </label>
          </div>

          <div class="mt-8 text-center">
            <v-btn
              v-if="!fetching && posts.length && (page.next || page.end_cursor)"
              @click="loadMore()" color="grey lighten-3" elevation="0" small
            >
              Load more
            </v-btn>
            <v-progress-circular v-if="fetching" color="primary" indeterminate size="25"></v-progress-circular>
          </div>
        </template>
      </template>
    </v-container>

    <br><br><br><br>

    <AddProductOptionsBottomNav/>

    <v-bottom-sheet v-model="visible" inset max-width="500" scrollable>
      <InstagramDetails v-if="current" :current="current" @done="handleAddDone()"/>
    </v-bottom-sheet>

    <v-snackbar :color="toast.color || ''" top v-model="toast.visible">
      {{ toast.message }}
    </v-snackbar>
  </div>
</template>

<script>
import ProxyImage from "@/components/ProxyImage";
import AddProductOptionsBottomNav from "@/components/standalone/merchants/AddProductOptionsBottomNav";
import InstagramDetails from "@/components/standalone/merchants/InstagramDetails";

export default {
  name: "MerchantAddProductsInstagram",
  components: { InstagramDetails, AddProductOptionsBottomNav, ProxyImage },
  data() {
    return {
      data: [],
      visible: false,
      toast: {
        visible: false,
        color: 'orange',
        message: ''
      },
      multiple: false,
      selection: [],
      adding: false,
      current: null,
      next: undefined,
      userId: undefined,
      posts: [],
      displayPosts: [],
      error: undefined,
      loading: '',
      fetching: false,
      view: 'initializing',
      username: '',
      page: {
        end_cursor: '',
        first_id: '',
        last_id: '',
        next: 0,
        pages: 0,
        end: false,
        total_count: 0
      },
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { merchant } = this.$store.state;
      if (merchant.instagram) {
        this.username = `${ merchant.instagram }`.replace('https://www.instagram.com/', '');
        await this.getSavedPosts();
      } else {
        this.view = 'username';
      }
    },
    async handleUsernameChange() {
      await this.getSavedPosts();
    },
    async getSavedPosts(page_number = 1) {
      try {
        if (page_number === 1) this.loading = 'Please wait..';
        else this.fetching = true;
        const res = await this.$http.get(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/merchant/instagram/${ this.username }`, {
          params: { page: page_number }
        })
        const { data, stored_data_exists, user_id, ...page } = res.data;
        if (!stored_data_exists) {
          this.fetching = false;
          return await this.initFetch();
        }
        this.posts = [...this.posts, ...data];
        this.displayPosts = this.posts;
        this.userId = user_id;
        this.page = page;
        this.view = 'list';
      } catch (e) {
        this.toast = {
          visible: true,
          color: 'red',
          message: `We couldn't fetch any data for ${ this.username }`,
        }
      }
      this.fetching = false;
      this.loading = '';
    },
    async initFetch() {
      this.loading = 'Fetching posts..';
      try {
        this.userId = await this.getInstagramId(this.username);
        const data = await this.fetchPosts();
        const posts = await this.savePosts(data);
        this.posts = posts;
        this.displayPosts = posts;
        this.view = 'list';
      } catch (error) {
        console.log(error);
        this.view = 'username';
        this.toast = {
          color: 'red',
          message: `We couldn't fetch any data for ${ this.username }`,
          visible: true
        };
      }
      this.loading = '';
    },
    async getInstagramId(username) {
      const res = await this.$http.get(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/insta/${ username }`);
      return res.data.id;
    },
    async fetchPosts(next = '', posts = []) {
      if (posts.length && !next) return { posts, next };
      if (posts.length >= 20) return { posts, next };
      try {
        const data = await this.getInstagramPosts(this.userId, next);
        const { posts: _posts, next: _next } = this.parseResponse(data);
        return { posts: _posts, next: _next };
      } catch (error) {
        if (posts.length) return { posts, next };
      }
    },
    async getInstagramPosts(userid, after = '', first = 80) {
      const params = { after, userid, first };
      const headers = {
        'x-rapidapi-key': 'bdac755d78msha920a8d278fd596p1adacbjsn1b1b384e667b',
        'x-rapidapi-host': 'instagram40.p.rapidapi.com',
      };
      const res = await this.$http.get(`https://instagram40.p.rapidapi.com/account-medias`, { headers, params });
      return res.data;
    },
    async loadMore() {
      if (this.page.next) await this.getSavedPosts(this.page.next);
      else if (this.page.end_cursor) {
        await this.continueFetch(this.page.end_cursor);
      }
    },
    async continueFetch(next) {
      this.fetching = true;
      try {
        const data = await this.fetchPosts(next);
        this.posts = await this.savePosts(data);
        this.displayPosts = this.posts;
      } catch (error) {
        this.toast = {
          visible: true,
          color: 'red',
          message: `We couldn't fetch any data for ${ this.username }`,
        }
      }
      this.fetching = false;
    },
    async refresh() {
      this.loading = `Fetching most recent posts from ${ this.username }`;
      try {
        const data = await this.fetchRecent();
        this.posts = await this.savePosts(data, false);
        this.displayPosts = this.posts;
      } catch {
        this.toast = {
          visible: true,
          color: 'red',
          message: `We couldn't fetch any data for ${ this.username }`,
        }
      }
      this.loading = '';
    },
    async fetchRecent(next = '', posts = [], failed = 0) {
      const exists = posts.reduce((acc, post) => {
        if (this.posts.find(p => p.id === post.id)) acc = true;
        return acc;
      }, false);
      if (exists) {
        posts = posts.filter(post => this.posts.find(p => p.id !== post.id));
        return { posts, next };
      }
      try {
        const data = await this.getInstagramPosts(this.userId, next);
        const { posts: _posts, next: _next } = this.parseResponse(data);
        return this.fetchRecent(_next, [...posts, ..._posts], failed);
      } catch (e) {
        if (failed === 1) return { posts, next };
        else return this.fetchRecent(next, [...posts], ++failed);
      }
    },
    parseResponse(response) {
      const posts = [];
      const { edges, page_info } = response;
      if (edges.length > 0) {
        edges.forEach(current => {
          const { node } = current;
          if (!(node).is_video) {
            const obj = {
              images: node.edge_sidecar_to_children
                ? (node.edge_sidecar_to_children.edges).map(e => e.node.display_url) : [node.thumbnail_src],
              description: node.edge_media_to_caption.edges.length
                ? node.edge_media_to_caption.edges[0].node.text : '',
              id: node.id,
            };
            posts.push(obj);
          }
        });
      }
      const next = page_info.has_next_page ? page_info.end_cursor : '';
      return { posts, next };
    },
    async savePosts({ next, posts }, append = true) {
      const payload = {
        slug: this.$route.params.mid,
        username: this.username,
        user_id: this.userId,
        first_id: posts[0].id,
        last_id: posts[posts.length - 1].id,
        end_cursor: append ? next : this.page.end_cursor,
        media: append ? [...this.posts, ...posts] : [...posts, ...this.posts]
      };
      await this.$http.post('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/merchant/instagram', payload);
      this.page.end_cursor = payload.end_cursor;
      return payload.media;
    },
    select(item) {
      this.current = {
        ...item,
        values: {
          name: item.description?.split(' ').slice(0, 10).join(' ') ?? '',
          price: this.getPrice(item.description),
        }
      };
      this.visible = true;
    },
    getPrice(description) {
      let priceMatch = description?.match(/((NGN|N) ?(\d+,?){2,})/g) || '';
      if (!priceMatch) priceMatch = description?.match(/\d+k/gi) || '';
      if (!priceMatch) priceMatch = description?.match(/(\d+,?){5,}/gi) || '';
      if (!priceMatch) priceMatch = description?.match(/(\d+,?){4,}/gi) || '';
      let price = (priceMatch && priceMatch[0]) ? priceMatch[0] : '';
      if (price) price = price.replace(/₦|NGN|N|,| /gi, '');
      if (price) price = price.replace(/k/gi, '000');
      return price;
    },
    handleAddDone() {
      this.visible = false;
      this.current = null;
      this.toast = {
        visible: true,
        color: 'green',
        message: 'Product added successfully'
      }
    },
    handleSelectionChange(id, value) {
      if (value) {
        if (!this.selection.includes(id)) this.selection = [...this.selection, id];
      } else {
        if (this.selection.includes(id)) this.selection = this.selection.filter(i => i !== id);
      }
    },
    changeUsername() {
      this.username = '';
      this.view = 'username';
    },
    async bulkAdd() {
      if (!this.selection.length) return;
      const bulk_items = this.selection.map(id => {
        const post = this.posts.find(it => it.id === id);
        return {
          name: post.description?.split(' ').slice(0, 10).join(' ') ?? '',
          price: this.getPrice(post.description) || '0',
          primary_picture: post.images[0],
          secondary_picture: post.images[1] ?? '',
          tertiary_picture: post.images[2] ?? '',
          fourth_picture: post.images[3] ?? '',
          fifth_picture: post.images[4] ?? '',
          slug: this.$route.params.mid,
          caption: post.description,
          sell_on_credit: "1"
        }
      });
      this.adding = true;
      await this.$http.post('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/merchant/status/bulk/item', {
        slug: this.$route.params.mid, bulk_items
      });
      this.adding = false;
      this.multiple = false;
      this.toast = {
        visible: true,
        color: 'green',
        message: 'Products added successfully'
      }
    }
  },
  watch: {
    visible(v) {
      if (!v) this.current = null;
    },
    multiple(v) {
      if (!v) this.selection = [];
    }
  }
}
</script>
